import { render, staticRenderFns } from "./PageEducatorInstitutionSponsorshipStudent.vue?vue&type=template&id=1b45a215&scoped=true&"
import script from "./PageEducatorInstitutionSponsorshipStudent.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionSponsorshipStudent.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionSponsorshipStudent.vue?vue&type=style&index=0&id=1b45a215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45a215",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
